import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Repair from "./pages/Repair";
import Parts from "./pages/Parts";
import Service from "./pages/Service";
import Contact from "./pages/Contact";
import Login from "./pages/Login";

import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import AdminProducts from "./pages/Dashboard/AdminProducts";
import AddProduct from "./pages/Dashboard/AddProductForm";
import AdminOrders from "./pages/Dashboard/AdminOrders";
import AdminSettings from "./pages/Dashboard/AdminSettings";
import AdminAnalysis from "./pages/Dashboard/AdminAnalysis";
import AdminRepairManager from "./pages/Dashboard/AdminRepairsManager";
import AdminParts from "./pages/Dashboard/AdminParts";
import AddPartForm from "./pages/Dashboard/AddPartsForm";

import UserDashboard from "./pages/Dashboard/UserDashboard";

import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";

import ProductDetails from "./pages/ProductDetails";
import PartDetails from "./pages/PartDetails";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import { ProductsProvider } from "./context/ProductsContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles.css";


// =======================
// LAYOUT
// =======================
const Layout = () => {
  const location = useLocation();

  const isDashboard =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/user");

  return (
    <>
      {!isDashboard && <Header />}

      <main style={{ padding: "2rem" }}>
        <Routes>

          {/* PUBLIC */}
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:brand/:model" element={<ProductDetails />} />
          <Route path="/parts/details/:id" element={<PartDetails />} />
          <Route path="/repair" element={<Repair />} />
          <Route path="/parts" element={<Parts />} />
          <Route path="/service" element={<Service />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />

          {/* ================= ADMIN LAYOUT ================= */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="products/add" element={<AddProduct />} />
            <Route path="repairs" element={<AdminRepairManager />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="analysis" element={<AdminAnalysis />} />
            <Route path="parts" element={<AdminParts />} />
            <Route path="parts/add" element={<AddPartForm />} />
          </Route>

          {/* ================= USER LAYOUT ================= */}
          <Route path="/user" element={<UserLayout />}>
            <Route path="dashboard" element={<UserDashboard />} />
          </Route>

        </Routes>
      </main>

      {!isDashboard && <Footer />}
    </>
  );
};

// =======================
// APP
// =======================
function App() {
  console.log("APP RENDERED");
  return (
    <AuthProvider>
      <ProductsProvider>
        <LanguageProvider>
          <Router>
            <Layout />
          </Router>
        </LanguageProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}

export default App;
